import { inject, Injectable } from '@angular/core';
import {
  ImageOptimisePreset,
  isImagePresetKey,
  mapImagePresetKeyToConfig,
  mapImagePresetKeyToConfigAtWidth,
  RmaSrcsetItem,
} from '@rma/generic/core/images';
import { appendToRmaCdnUrl, appendToRmaImagesUrl } from '@rma/generic/ng/util';

@Injectable({
  providedIn: 'root',
})
export class ImageOptimiseService {
  private readonly appendImageUrl = inject(appendToRmaImagesUrl);
  private readonly appendToCdnUrl = inject(appendToRmaCdnUrl);

  private readonly cdnUrl = this.appendToCdnUrl('');

  public getFromPreset(value: string | undefined | null, preset: ImageOptimisePreset = 'Fallback'): string {
    const resolved = isImagePresetKey(preset) ? preset : 'Fallback';
    if (resolved !== preset) {
      console.error(`ImageOptimiseService: unknown image preset "${preset}"; falling back to "Fallback" for url "${value}"`);
    }
    return this.buildOptimisedUrl(value, mapImagePresetKeyToConfig(resolved));
  }

  /** The preset scaled to `width` for a responsive `srcset`; see `mapImagePresetKeyToConfigAtWidth`. */
  public getFromPresetAtWidth(value: string | undefined | null, preset: ImageOptimisePreset = 'Fallback', width: number): string {
    const resolved = isImagePresetKey(preset) ? preset : 'Fallback';
    if (resolved !== preset) {
      console.error(`ImageOptimiseService: unknown image preset "${preset}"; falling back to "Fallback" for url "${value}"`);
    }
    return this.buildOptimisedUrl(value, mapImagePresetKeyToConfigAtWidth(resolved, width));
  }

  public getSrcSetFromCdn(value: string, config: RmaSrcsetItem[]): string {
    return config.map((i) => `${this.getFromPreset(value, i.optimisation)} ${i.width}`).join();
  }

  private buildOptimisedUrl(value: string | undefined | null, params: string): string {
    if (!value) {
      return '';
    }

    if (!value.includes(this.cdnUrl)) {
      return value;
    }

    const path = value.replace(this.cdnUrl, '');
    return `${this.appendImageUrl(path)}?${params}`;
  }
}
